const initState = {
  // selectedVideo: {},
  attachmentLibraryData: [],
  attachmentLibraryDataCount: 0,
  attachmnetPagination: {
    page: 1,
    limit: 12,
    total: 0,
    totalPages: 0,
  },
};
const attachmentLibraryReducer = (state = initState, action) => {
  switch (action.type) {
    case "SET_ATTACHMENT_LIBRARY_DATA":
      return {
        ...state,
        attachmentLibraryData: action.payload.data,
      };
    case "SET_ATTACHMENT_LIBRARY_DATA_COUNT":
      return {
        ...state,
        attachmentLibraryDataCount: action.payload.data,
      };
    // case "SET_SELECTED_VIDEO":
    //   return {
    //     ...state,
    //     selectedVideo: action.payload.data,
    //   };

    case "SET_ATTACHMENT_PAGINATION":
      return {
        ...state,
        attachmnetPagination: action.payload.data,
      };

    default:
      return { ...state };
  }
};

export default attachmentLibraryReducer;
